export const ITEMS_BAR: { key: TabKey; label: string; icon: string; path?: string; children?: { key: TabKey; label: string; path: string; }[]; expanded?: boolean }[] =
    [
      {
        key: 'inicio',
        label: 'Inicio',
        icon: '/shell/navbar/menu.svg',
        path: 'promotor-dashboard',
      },
      {
        key: 'mis-datos',
        label: 'Mis datos',
        icon: '/member/dashboard/user-square.svg',
        path: 'promotor-my-data',
      },
      {
        key: 'mi-wallet',
        label: 'Mi wallet',
        icon: '/member/dashboard/wallet.svg',
        path: 'promotor-wallet',
      },
      {
        key: 'reservas',
        label: 'Reservas',
        icon: '/member/dashboard/fi-rr-bed.svg',
        children: 
        [
          {
            key: 'disponibles',
            label: 'Disponibles',
            path: 'promotor-bookings'
          },
          {
            key: 'reservados',
            label: 'Reservados',
            path: 'promotor-member-booking-feature/active-bookings'
          },
          {
            key: 'historicos',
            label: 'Históricos',
            path: 'promotor-member-booking-feature/booking-history'
          },
        ],
        expanded: false
      },
      {
        key: 'fullday',
        label: 'Fullday',
        icon: '/member/dashboard/fullday.svg',
        // path: 'fullday',
        children: 
        [
          {
            key: 'disponibles',
            label: 'Disponibles',
            path: 'fullday'
          },
          {
            key: 'reservados',
            label: 'Reservados',
            path: 'fullday/reservados'
          },
          {
            key: 'historicos',
            label: 'Históricos',
            path: 'fullday/historico'
          },
        ],
        expanded: false
      },
      {
        key: 'beneficios',
        label: 'Beneficios',
        icon: '/member/dashboard/benefit.svg',
        path: 'promotor-my-benefits',
      },
      {
        key: 'clientes',
        label: 'Mis clientes',
        icon: '/member/dashboard/user-double.svg',
        path: 'promotor-my-clients',
      },
      {
        key: 'comisiones',
        label: 'Mis comisiones',
        icon: '/member/dashboard/commissions.svg',
        path: 'promotor-my-commissions',
      },
      {
        key: 'cursos',
        label: 'Cursos',
        icon: '/member/dashboard/courses.svg',
        path: 'promotor-courses',
      },
    ];

export type TabKey =
  | 'inicio'
  | 'mis-datos'
  | 'reservas'
  | 'mi-wallet'
  | 'beneficios'
  | 'recompensas'
  | 'fullday'
  | 'clientes'
  | 'comisiones'
  | 'cursos'
  | 'disponibles'
  | 'reservados'
  | 'historicos'
  | '-';